import React from 'react';

import {useRunsLinePlotContext} from './RunsLinePlotContext/RunsLinePlotContext';
import {
  SamplingWarningView,
  type SamplingWarningViewProps,
} from './SamplingWarningView';

type SamplingWarningProps = Pick<SamplingWarningViewProps, 'style' | 'width'>;

/**
 * Reads the panel's sampling fallback state and renders SamplingWarningView.
 */
export const SamplingWarning = React.memo(function SamplingWarning({
  style,
  width,
}: SamplingWarningProps) {
  const {isSamplingFallback, warningMessages} = useRunsLinePlotContext();

  return (
    <SamplingWarningView
      isSamplingFallback={isSamplingFallback}
      style={style}
      warningMessages={warningMessages}
      width={width}
    />
  );
});
SamplingWarning.displayName = 'SamplingWarning';
